// Module
var code = `<amt-chart ng-if="sense_evetns_loaded" name="admin_events.IncomeEventsChart" cdata="sense_evetns_chart_data">

</amt-chart>
`;
// Exports
module.exports = code;